<template>
  <div style="height: 100%">
    <BaseContainer style="height: 100%" class="one_table">
      <TableMain :table_height_default="table_height" name="one table" ref="TempQuotationItemTable" :fields="fields"
        :title="table_title.title1" :show_query_container="true" :show_toolbar_container="true"
        :show_pagination_container="true" :show_date_picker="false" :show_toolbar="true" :show_filter="true"
        :date_picker_label="date_picker_label" :query_button_label="query_lable" :isBusy="isBusy" @on_query="on_query"
        @state_change="state_change" :show_toolbar_button="[0, 0, 0, 0, 1]" @tool_invoke="tool_invoke"
        @on_cell_button_click="on_cell_button_click" hb_table_class="hb_table_temp_quotation_item_class1">
        <template #toolbar>
          <el-button type="info" plain @click="createData()" class="ml-2 iconfont icon-add-new" size="mini">
            {{ $t('common.new') }}
          </el-button>
          <el-popover placement="right" v-model="visible" trigger="click">
            <div style="text-align: right; margin: 0" class="w-100">
              <el-form label-width="80px">
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="配比数">
                      <el-input-number v-model="matchA" type="number" :controls="false"></el-input-number>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="比">
                      <el-input-number v-model="matchB" type="number" :controls="false"></el-input-number>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-form-item>
                  <el-button type="primary" size="mini" @click="selectItemToParent">确定</el-button>
                </el-form-item>
              </el-form>
            </div>
            <el-button slot="reference" type="info" plain @click="() => { selectItemsUseCount = 0 }"
              class="ml-2 iconfont icon-down2" size="mini" v-if="showSelectButton">
              {{ $t('common.selected') }}
            </el-button>
          </el-popover>

        </template>
        <template #query>
          <el-input placeholder="物料名称" class="ml-1" clearable size="small" style="width: 180px"
            v-model="searchModel.ItemName"></el-input>
          <el-select placeholder="物料类型" size="small" v-model="searchModel.ItemTypeId" filterable clearable
            class="w-5 ml-1">
            <el-option v-for="item in $store.state.biz_data.baseData.ItemType" :key="item.id" :label="item.itemTypeName"
              :value="item.id"></el-option>
          </el-select>
        </template>
      </TableMain>
    </BaseContainer>
    <!-- 编辑modal -->
    <BaseModal ref="TempItemModal" :title="wrkctr_modal_title" @saveData="SaveData" :width="'40%'"
      :mask="!showSelectButton">
      <template #modal_content>
        <el-form :rules="rules" :model="ItemModel" ref="dataForm" label-width="100px" class="demo-dataForm">
          <el-row>
            <el-col :span="12"><el-form-item label="物料类型" prop="ItemTypeId">
                <el-select placeholder="请选择物料类型" size="small" v-model="ItemModel.ItemTypeId" filterable clearable
                  class="w-100" @change="selectItemType" :disabled="ItemModel.id != ''">
                  <el-option v-for="item in $store.state.biz_data.baseData.ItemType" :key="item.id"
                    :label="item.itemTypeName" :value="item.id"></el-option>
                </el-select> </el-form-item></el-col>
            <el-col :span="12"><el-form-item label="物料名称" prop="ItemName">
                <el-input clearable v-model="ItemModel.ItemName" placeholder="请输入物料名称"
                  :disabled="ItemModel.id != ''"></el-input> </el-form-item></el-col>
          </el-row>
          <el-row>
            <el-col :span="12"><el-form-item :label="ItemModel.ItemTypeId == 1 ? '克重' : '规格'" prop="Spec">
                <el-input clearable v-model="ItemModel.Spec" placeholder="请输入"
                  :disabled="getDisabled('Spec')"></el-input> </el-form-item></el-col>
            <el-col :span="12"><el-form-item label="上机长mm" prop="TEC_GoLength">
                <el-input-number style="width: 100%" v-model="ItemModel.TEC_GoLength" type="number"
                  :disabled="getDisabled('TEC_GoLength')" :controls="false"></el-input-number>
              </el-form-item></el-col>
          </el-row>
          <el-row>
            <el-col :span="12"><el-form-item label="上机宽mm" prop="TEC_GoWidth">
                <el-input-number style="width: 100%" v-model="ItemModel.TEC_GoWidth" type="number"
                  :disabled="getDisabled('TEC_GoWidth')" :controls="false"></el-input-number>
              </el-form-item></el-col>
            <el-col :span="12"><el-form-item label="排版模数" prop="Mould_Count">
                <el-input-number style="width: 100%" v-model="ItemModel.Mould_Count" type="number"
                  :disabled="getDisabled('Mould_Count')" :controls="false"></el-input-number>
              </el-form-item></el-col>
          </el-row>
          <el-row>
            <el-col :span="12"><el-form-item label="用料长mm" prop="UseLength">
                <el-input-number style="width: 100%" v-model="ItemModel.UseLength" type="number"
                  :disabled="getDisabled('UseLength')" :controls="false"></el-input-number>
              </el-form-item></el-col>
            <el-col :span="12">
              <el-form-item label="用料宽mm" prop="UseWidth">
                <el-input-number style="width: 100%" v-model="ItemModel.UseWidth" type="number"
                  :disabled="getDisabled('UseWidth')" :controls="false"></el-input-number>
              </el-form-item></el-col>
          </el-row>
          <el-row>
            <el-col :span="12"><el-form-item label="开数" prop="Cut_Count">
                <el-input-number style="width: 100%" v-model="ItemModel.Cut_Count" type="number"
                  :disabled="getDisabled('Cut_Count')" :controls="false"></el-input-number>
              </el-form-item></el-col>
            <el-col :span="12"><el-form-item label="计量单位" prop="Unit_Use">
                <el-select placeholder="请选择计量单位" size="small" v-model="ItemModel.Unit_Use" filterable clearable
                  class="w-100" :disabled="getDisabled('Unit_Use')">
                  <el-option v-for="item in $store.state.biz_data.baseData.UnitOfMeasure" :key="item.Symbol"
                    :label="item.Symbol" :value="item.Symbol"></el-option>
                </el-select> </el-form-item></el-col>
          </el-row>
          <el-row v-if="ItemModel.ItemTypeId == 1">
            <el-col :span="24"><el-form-item label="单价(元)">
                <el-input placeholder="请输入内容" v-model="calc.unit_price">
                  <el-select v-model="calc.unit_weight" slot="prepend" placeholder="请选择" style="width: 100px;">
                    <el-option label="吨" :value="1000000"></el-option>
                    <el-option label="千克" :value="1000"></el-option>
                    <el-option label="克" :value="1"></el-option>
                  </el-select>
                  <el-button slot="append" @click="calcUnitPrice">计算</el-button>
                </el-input> </el-form-item></el-col>
          </el-row>
          <el-row>
            <el-col :span="12"><el-form-item label="单位成本" prop="Unit_Price">
                <el-input-number style="width: 100%" v-model="ItemModel.Unit_Price" type="number" :controls="false">
                </el-input-number> </el-form-item></el-col>
            <el-col :span="12"><el-form-item label="成本组" prop="CostGroupId">
                <el-select placeholder="成本组" size="small" v-model="ItemModel.CostGroupId" filterable clearable
                  class="w-100">
                  <el-option v-for="item in costGroupOptions" :key="item" :label="item" :value="item"></el-option>
                </el-select>
              </el-form-item></el-col>
          </el-row>

          <el-form-item label="备注" prop="Derscription">
            <el-input type="textarea" clearable v-model="ItemModel.Description" maxlength="500"
              show-word-limit></el-input>
          </el-form-item>
        </el-form>
      </template>
    </BaseModal>
  </div>
</template>

<script>
import BaseContainer from '../components/BaseContainer'
import TableMain from '../components/table/TableMain'
import BaseModal from '../components/modals/baseModal'
import * as TempQuotationItemController from '../../controllers/sd/TempQuotationItemController'

export default {
  components: {
    BaseContainer,
    TableMain,
    BaseModal,
  },
  props: {
    table_height: { type: String, default: '' },
    showSelectButton: { type: Boolean, default: false },
  },
  data() {
    return {
      calc: {
        unit_weight: 1000000,
        unit_price: 0,
      },
      costGroupOptions: [
        'EXP', 'FA', 'M11纸张', 'M21油墨', 'M22光油', 'M23胶水', 'M24CTP版', 'M25其他辅料', 'M26办公劳保', 'O11直接人工', 'O12间接人工', 'O23电', 'O24折旧', 'O25其他变动费用', 'O26其他固定费用', 'S11委外加工费', 'X备件', 'Y半成品', 'Z成品'
      ],
      visible: false,
      selectItemsUseCount: 0,
      matchA: 1,
      matchB: 1,
      tableHeight: 100,
      showPassword: true,
      searchModel: {
        ItemName: '',
        ItemTypeId: '',
      },
      ItemModel: {
        id: '',
        ItemTypeId: '',
        ItemName: '',
        TEC_GoLength: null,
        TEC_GoWidth: null,
        Mould_Count: null,
        UseLength: null,
        UseWidth: null,
        Cut_Count: null,
        Unit_Use: null,
        Unit_Price: null,
        Spec: null,
        Description: '',
        CostGroupId: null
      },
      date_picker_label: 'common.search',
      query_lable: this.$t('common.query'),
      table_title: {
        title1: '物料类型',
      },
      fields: TempQuotationItemController.fields.default,
      rules: {
        ItemTypeId: [{ required: true, message: '请选择', trigger: 'change' }],
        ItemName: [{ required: true, message: '请输入', trigger: 'blur' }],
        // Unit_Price: [{ required: true, message: '请输入', trigger: 'blur' }],
        // CostGroupId: [{ required: true, message: '请选择', trigger: 'change' }],
      },
      disabled_keys: [],
      wrkctr_modal_title: '',
      isBusy: false,
    }
  },
  created() {
    //console.log(this.tableHeight);
  },
  mounted() { },
  methods: {
    //计算单位成本
    calcUnitPrice() {
      if (this.ItemModel.ItemTypeId != 1) {
        this.msgToasts('非纸张无法计算!', 'warning')
        return
      }
      if (!this.ItemModel.UseLength || !this.ItemModel.UseWidth || !this.ItemModel.Mould_Count || !this.ItemModel.Cut_Count || !this.calc.unit_price) {
        this.msgToasts('计算参数非法,请检查 用料长、用料宽、模数、切数、单位(元)!', 'warning')
        return
      }
      //单位成本 = 用料宽*用料长*克重*单位单价/(单位克重系数)/模数/切数
      this.ItemModel.Unit_Price = _.round((this.ItemModel.UseLength / 1000 * this.ItemModel.UseWidth / 1000 * JSON.parse(this.ItemModel.Spec) * this.calc.unit_price / this.calc.unit_weight / this.ItemModel.Cut_Count / this.ItemModel.Mould_Count), 12);
    },
    selectItemToParent() {
      if (this.$refs.TempQuotationItemTable.GetSelectedItems().length < 1) {
        this.msgToasts('请先选择数据!', 'warning')
        return
      }
      if (this.matchA <= 0 || this.matchB <= 0) {
        this.msgToasts('配比数必须大于0!', 'warning')
        return
      }
      this.$emit(
        'EmitTempQuotationItem',
        this.$refs.TempQuotationItemTable.GetSelectedItems(),
        this.matchA,
        this.matchB
      )
      this.visible = false
    },
    getDisabled(key) {
      return (
        _.findIndex(this.disabled_keys, function (o) {
          return o === key
        }) > -1
      )
    },
    selectItemType(val) {
      this.$refs.dataForm.resetFields()
      this.clearData()
      this.ItemModel.ItemTypeId = val
      this.rules = this.getRules(val, this.ItemModel)
      //this.$set(this.rules, 'CostGroupId', [{ required: true, message: '请选择', trigger: 'change' }])
    },

    getRules(itemTypeId, checkData) {
      this.disabled_keys = []
      let item = _.find(
        this.$store.state.biz_data.baseData.ItemType,
        function (o) {
          return o.id === itemTypeId
        }
      )
      let rules = {
        ItemTypeId: [{ required: true, message: '请选择', trigger: 'change' }],
        ItemName: [{ required: true, message: '请输入', trigger: 'blur' }],
        //Unit_Price: [{ required: true, validator: TempQuotationItemController.validatePositive, trigger: 'blur' }],
      }
      if (item) {
        for (var key in item) {
          if (checkData.hasOwnProperty(key)) {
            if (item[key] === 0 && key !== 'Unit_Use' && key !== 'Spec') {
              rules[key] = [
                { required: true, validator: TempQuotationItemController.validatePositive, trigger: 'blur' },
              ]
            }
            if (item[key] === 0 && key === 'Spec') {
              rules[key] = [
                { required: true, message: '请输入规格', trigger: 'blur' },
              ]
            }
            if (item[key] === 0 && key === 'Unit_Use') {
              rules[key] = [
                { required: true, message: '请选择', trigger: 'change' },
              ]
            }
            if (item[key] === 2) {
              this.disabled_keys.push(key)
            }
          }
        }

        return rules
      }
    },
    getCompanyOptions() {
      return _.map(this.$store.state.biz_data.baseData.CompanyInfo, (v) => {
        return {
          value: v.DataArea,
          label:
            v.DataArea + ':' + (v.CompanyName === null ? '' : v.CompanyName),
        }
      })
    },
    //#region 查询
    async on_query(set_data) {
      const _this = this
      this.isBusy = true
      set_data([])
      let p = { is_deleted: { '=': 0 } }

      if (this.searchModel.ItemName.trim() != '') {
        p.ItemName = { like: '%' + this.searchModel.ItemName + '%' }
      }
      if (this.searchModel.ItemTypeId) {
        p.ItemTypeId = { '=': this.searchModel.ItemTypeId }
      }
      let _result = await TempQuotationItemController.methods.getData(p)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        _.each(_result[0], (t) => {
          t.ItemTypeName = _.find(
            _this.$store.state.biz_data.baseData.ItemType,
            function (o) {
              return o.id === t.ItemTypeId
            }
          ).itemTypeName
        })

        set_data(_.orderBy(_result[0], ['id'], ['desc']))
      }
      this.isBusy = false
    },
    //#endregion
    //#region 状态切换
    async state_change(data, cb) {
      if (data.selected_items.length == 0) {
        this.msgToasts(this.$t('notify.not_data'), 'info')
        cb(false)
        return
      }
      let ask = await this.msgModal(this.$t('notify.is_deleted'))
      if (!ask) {
        cb(false)
        return
      }
      let p = {}
      p.delete = data.selected_items
      let rt = await TempQuotationItemController.methods.saveData(p)
      if (rt) {
        this.$refs.TempQuotationItemTable.RemoveItems(rt[0])
        this.msgToasts(this.$t('notify.action_successfully'), 'success')
        cb(true)
      } else {
        this.msgToasts(this.$t('notify.action_unsuccessfully'), 'error')
        cb(false)
      }
    },
    //#endregion

    //#region 打印导出
    tool_invoke(data, cb) {
      if (data.tool == 'adhoc_report') {
        let _data = {
          state: true,
          fields: this.fields,
          title: this.$t('table.table_customer'),
          sheet_title: '物料类型档案',
        }
        ///调用公用导出(如果调用特定导出则可以写在这里)
        cb(_data)
      } else {
        ///调用公用打印(如果调用特定打印则可以写在这里)
        cb(null)
      }
    },
    //#endregion
    clearData() {
      this.ItemModel = {
        id: '',
        ItemTypeId: '',
        ItemName: '',
        TEC_GoLength: null,
        TEC_GoWidth: null,
        Mould_Count: null,
        UseLength: null,
        UseWidth: null,
        Cut_Count: null,
        Unit_Use: null,
        Spec: null,
        Unit_Price: null,
        Description: '',
      }
    },
    ///新增、编辑
    createData() {
      this.wrkctr_modal_title = '新建物料类型'
      this.clearData()
      this.$refs.TempItemModal.show()
      this.calc.unit_price = 0
      this.calc.unit_weight = 1000000
    },
    on_cell_button_click(data) {
      this.wrkctr_modal_title = '编辑物料类型'
      for (let key in this.ItemModel) {
        if (data.item.hasOwnProperty(key)) {
          this.ItemModel[key] = data.item[key]
        }
      }

      this.$refs.TempItemModal.show()
      this.calc.unit_price = 0
      this.calc.unit_weight = 1000000
    },
    //新增
    async addItemType(cb) {
      let p = _.cloneDeep(this.ItemModel)
      for (var key in p) {
        if (!p[key]) {
          p[key] = null
        }
      }
      let rt = await TempQuotationItemController.methods.saveData({
        add: p,
      })
      if (rt) {
        rt[0].ItemTypeName = _.find(
          this.$store.state.biz_data.baseData.ItemType,
          function (o) {
            return o.id == rt[0].ItemTypeId
          }
        ).itemTypeName
        this.$refs.TempQuotationItemTable.InsertItems(rt[0])
        cb(true, true)
      } else {
        cb(false)
      }
    },
    //更新
    async updateItemType(cb) {
      let p = _.cloneDeep(this.ItemModel)
      for (var key in p) {
        if (!p[key]) {
          p[key] = null
        }
      }
      let rt = await TempQuotationItemController.methods.saveData({
        edit: p,
      })
      if (rt) {
        let tm = _.find(this.$refs.TempQuotationItemTable.my_data, {
          id: rt[0].id,
        })
        if (tm) {
          Object.assign(tm, rt[0])
        }
        cb(true, true)
      } else {
        cb(false)
      }
    },
    async SaveData(cb) {
      //数据验证
      this.$refs.dataForm.validate(async (valid) => {
        if (valid) {
          //新增或保存过程
          if (this.ItemModel.id == '') await this.addItemType(cb)
          else await this.updateItemType(cb)
        } else {
          cb(true, false, '')
          return
        }
      })
    },
  },
}
</script>
<style>
.hb_table_temp_quotation_item_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 150rem;
}
</style>
